import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PagesComponent} from './pages.component';

const routes: Routes = [
  /*  {path: 'login', loadChildren: 'app/login/login.module#LoginModule'},*/
  {
    path: 'pages', component: PagesComponent,
    children: [
      /*    { path: 'homesortcut', loadChildren: 'app/pages/homesortcut/homesortcut.module#HomesortcutModule' },*/
    ]
  }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/pages/pages.routing.ts